// src/views/kiddo-games/writing/WordFromList.tsx
// Kopia src/components/Writing/WordFromList.tsx — tylko dla Napisz Easy.
// Nad ramką z polskim słowem stoi obrazek słowa w osobnej ramce, jak w grze Powtórz.
/* eslint-disable max-len */
import React, { FC } from 'react';
import { WritingInput } from './WritingInput';
import { FitText } from '../../../components/FitText/FitText';
import classes from './WordFromList.module.less';

type CardProps = {
  id: any,
  content: string,
  term: string,
  translation: string,
  image?: string,
  setNextWordButton: any,
  setFeedbackInfo: any,
  setTryAgainButton: any;
  setInputContent: any;
  inputContent: any;
  tryAgainButton: boolean;
  tryAgain: any;
  onCorrect: () => void;
  answeredCorrectly: boolean;
};

export const WordFromList: FC<CardProps> = ({
  content, term, id, translation, image,
  setInputContent, inputContent,
  tryAgainButton, tryAgain,
  setNextWordButton,
  setFeedbackInfo,
  setTryAgainButton,
  onCorrect,
  answeredCorrectly,
}) => (
  <>
    {/* Na telefonie trzymanym poziomo obrazek i karta stoją obok siebie, a pole pod nimi (WordFromList.module.less) */}
    <div className={classes.cardRow}>
      {/* Ramka stoi też bez obrazka, jak w Powtórz — karta, pole i przyciski nie skaczą między słowami */}
      <div className={classes.pict}>
        {/* alt pusty — to samo słowo stoi pod spodem jako napis */}
        {image && <img src={image} alt="" />}
      </div>
      {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
      <FitText
        className={classes.word}
        id={id}
      >
        {translation}
      </FitText>
    </div>
    <div>
      <WritingInput
        content={content}
        term={term}
        setNextWordButton={setNextWordButton}
        setFeedbackInfo={setFeedbackInfo}
        setTryAgainButton={setTryAgainButton}
        setInputContent={setInputContent}
        tryAgainButton={tryAgainButton}
        tryAgain={tryAgain}
        inputContent={inputContent}
        onCorrect={onCorrect}
        answeredCorrectly={answeredCorrectly}
      />
    </div>
  </>
);

export default WordFromList;
